/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Badge,
  Flex,
  Spacer,
  Stack,
} from '@chakra-ui/react';
import { Heading, Icon, Text } from '@diamond/shared/ui';
import { LocationOnOutlined } from '@mui/icons-material';
import ChevronRight from '@mui/icons-material/ChevronRight';

export interface AlamatPengirimanProps {
  alamat: string;
  pemesan: string;
  noHP: string;
  warehouseName?: string;
  showNewBadge?: boolean;
  delivery_option:
    | 'immediate'
    | 'custom_date_2'
    | 'custom_date_3'
    | 'custom_date_4'
    | 'custom_date_5';
  delivery_date: string;
  delivery_note: string | null;
}

export function CardAlamatPengiriman({
  alamat,
  pemesan,
  delivery_date,
  delivery_option,
  noHP,
  delivery_note,
  warehouseName,
  showNewBadge,
}: AlamatPengirimanProps) {
  const handleTextDate = () => {
    let text = '';
    switch (delivery_option) {
      case 'custom_date_2':
        text = `H+2 Pemesanan • ${delivery_date}`;
        break;

      case 'custom_date_3':
        text = `H+3 Pemesanan • ${delivery_date}`;
        break;

      case 'custom_date_4':
        text = `H+4 Pemesanan • ${delivery_date}`;
        break;

      case 'custom_date_5':
        text = `H+5 Pemesanan • ${delivery_date}`;
        break;

      default:
        text = `Pengiriman Segera`;
        break;
    }
    return text;
  };
  return (
    <Accordion
      allowToggle
      borderRadius="8px"
      boxShadow="none"
      bg="none"
      borderWidth="1px"
      borderColor="rgba(217, 217, 217, 1)"
    >
      <AccordionItem borderWidth="0 !important">
        <AccordionButton py="4" data-testid="accordion-button" border="none">
          <Flex alignItems="center" justifyContent="space-between" w="full">
            <Flex
              alignItems="center"
              gap="2"
              fontSize={{ base: 'sm', md: 'xl' }}
              flex={1}
            >
              <Icon as={LocationOnOutlined} color="blue" boxSize="32px" />
              <Flex
                alignItems={{ base: 'flex-start', md: 'center' }}
                direction={{ base: 'column', md: 'row' }}
                flex={1}
                gap={{ base: 1, md: 2 }}
              >
                <Heading
                  fontSize={{ base: '14px', md: '20px' }}
                  fontWeight="700"
                  lineHeight="100%"
                  letterSpacing="0.0015em"
                >
                  Alamat Pengiriman
                </Heading>
                {warehouseName && (
                  <>
                    <Icon
                      as={ChevronRight}
                      display={{ base: 'none', md: 'block' }}
                      boxSize="20px"
                      color="black"
                    />
                    <Text
                      fontSize={{ base: '16px', md: '20px' }}
                      fontWeight="600"
                      lineHeight="100%"
                      letterSpacing="0"
                      color="#0000A3"
                    >
                      {warehouseName}
                    </Text>
                  </>
                )}
              </Flex>
            </Flex>
            <AccordionIcon />
          </Flex>
        </AccordionButton>
        <AccordionPanel pb="4">
          <Stack spacing={4} fontSize={{ base: '2xl', md: 'lg' }}>
            <Stack direction={{ base: 'column', md: 'row' }} spacing="1">
              <Text color="gray.75">Alamat Lengkap</Text>
              <Spacer display={{ base: 'none', md: 'flex' }} />
              <Text fontWeight={{ md: 'semibold' }}>{alamat}</Text>
            </Stack>
            <Stack direction={{ base: 'column', md: 'row' }} spacing="1">
              <Text color="gray.75">Nama Penerima</Text>
              <Spacer display={{ base: 'none', md: 'flex' }} />
              <Text fontWeight={{ md: 'semibold' }}>{pemesan}</Text>
            </Stack>
            <Stack direction={{ base: 'column', md: 'row' }} spacing="1">
              <Text color="gray.75">Nomor HP</Text>
              <Spacer display={{ base: 'none', md: 'flex' }} />
              <Text fontWeight={{ md: 'semibold' }}>{noHP}</Text>
            </Stack>
            <Stack direction={{ base: 'column', md: 'row' }} spacing="1">
              <Text color="gray.75">Tanggal Pengiriman</Text>
              <Spacer display={{ base: 'none', md: 'flex' }} />
              <Text fontWeight={{ md: 'semibold' }}>{handleTextDate()}</Text>
            </Stack>
            {delivery_note && (
              <Stack direction={{ base: 'column', md: 'row' }} spacing="1">
                <Text color="gray.75">Catatan Pengiriman</Text>
                <Spacer display={{ base: 'none', md: 'flex' }} />
                <Text
                  fontWeight={{ md: 'semibold' }}
                  w={48}
                  textAlign={{ base: 'left', md: 'right' }}
                >
                  {delivery_note}
                </Text>
              </Stack>
            )}
          </Stack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}

export default CardAlamatPengiriman;
